// Filename: public/utilities.js

function ToBase64(u8) {
	return btoa(String.fromCharCode.apply(null, u8));
}

export function getBase64(surname, name, email) {
	let subtleCrypto = crypto.subtle;
	// formattin date time to dd/mm/yyyy and convert it to a Buffer array
	const date = new Date();
	const todayDate = date.toLocaleDateString(undefined, { year: "numeric", month: '2-digit', day: '2-digit' })
	const dateBuffer = new TextEncoder().encode(todayDate);

	// Calculate first hash from: Association pass key + form params
	const SecretKeyformParams = `Emergenz4S0rrisi!&ana1=${surname}&ana2=${name}&email=${email}`;
	const SecretKeyformParamsBuffer = new TextEncoder().encode(SecretKeyformParams);
	return subtleCrypto.digest('SHA-256', SecretKeyformParamsBuffer).then((SecretKeyformParamsHash) => {
		// Concat date buffer with first hash Buffer
		let completeBuffer = new Uint8Array(dateBuffer.buffer.byteLength + SecretKeyformParamsHash.byteLength)
		completeBuffer.set(dateBuffer, 0)
		completeBuffer.set( new Uint8Array(SecretKeyformParamsHash), dateBuffer.length)
		return subtleCrypto.digest('SHA-256', completeBuffer).then((completeBufferHash) => {
			// Calculate final hash and convert it to base64
			var base64 = ToBase64(new Uint8Array(completeBufferHash));
			return base64
		});
	});
}